import { ISupportTypeInfo } from '../../shared';
import { TFunction } from 'i18next';

export function supportTypesInfoFormatter(t: TFunction, supportTypesInfo?: ISupportTypeInfo[]): string {
    if (!supportTypesInfo?.length) return '';
    return supportTypesInfo
        ?.map(
            ({ supportType, frequency, credit }) =>
                `${supportType?.name}${credit && frequency ? ` (${t(frequency)} €${credit.toString().replace('.', ',')})` : ''}`,
        )
        .join(', ');
}
